import Vue from 'vue'
import Vuex from 'vuex'
import auth from './auth'
import barpin from './barpin'
import tfa from './tfa'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    auth,
    barpin,
    tfa
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js